import React, {ReactElement, useEffect, useState} from 'react';
import './App.scss';

import {AppProvider} from "./context/AppContext";
import {CategoryProvider} from "./context/CategoryContext";
import Layout from "./page/Layout";
import {DrawerProvider} from "./context/DrawerContext";
import {BookingInfoProvider} from "./context/BookingInfoContext";
import {BrowserRouter} from "react-router-dom";
import 'font-awesome/css/font-awesome.min.css';
import "./module/booking/style/booking.scss"
import AppUtil from './util/AppUtil';
import _ from 'lodash';
import 'moment/min/locales';

const App = (): ReactElement => {
    return (
        <div className="app-module" style={{height: "100%"}}>
            
                <AppProvider>
                    <CategoryProvider>
                        <DrawerProvider>
                            <BookingInfoProvider>
                                <BrowserRouter>
                                    <Layout/>
                                </BrowserRouter>
                            </BookingInfoProvider>
                        </DrawerProvider>
                    </CategoryProvider>
                </AppProvider>
        </div>
    );
}

export default App;
